import React from 'react'
import styled from 'styled-components'
import "./VideoModal.css"

const VideoModal = ({ top }) => {
    return (
        <div className="VideoModalWrapper" top={top}>
            <div className="videoContainer">
                <video id="player1" controls autoPlay>
                    <source type="video/mp4" src="https://d2y132o5jei9jv.cloudfront.net/static/RedcliffeLifeTech+ClinicalPathologyLab.mp4" />
                </video>
            </div>
        </div>
    )
}


export default VideoModal
